import { Modal, Button, Text, Group, Title } from "@mantine/core";

const ModalDialog = ({ opened, onClose, onConfirm, title, description, confirmColor }) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={(<b>{title}</b>)}
      centered
      withCloseButton={false}
      closeOnClickOutside={false}
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 1,
      }}
    >
      {typeof description === "string" ? (
        <Text mb="lg">{description}</Text>
      ) : (
        description
      )}
      <Group justify="flex-end" gap="md" mt={'lg'} wrap="nowrap">
        <Button variant="default" onClick={onClose}>
          Cancelar
        </Button>
        <Button color={confirmColor} onClick={onConfirm} w={150}>
          Continuar
        </Button>
      </Group>
    </Modal>
  );
};

export default ModalDialog;